export default __webpack_public_path__ + "static/media/icons-maintenance-data-category.6e6aff7d.svg";